import { Injectable } from '@angular/core';
import { Authentication } from '../models/Authentication';
import { environment } from '../../environments/environment';
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  headers = new HttpHeaders();
  
  country: string;
  language: string;

  constructor(private readonly http: HttpClient) { }

  /**
   * 
   * @param dataForm get token
   */
  getAuthentication(dataForm, captcha, params) {
    this.language = sessionStorage.getItem('language');
    this.country = sessionStorage.getItem('country') || 'ES';
    let body = {
      Channel: params[1] ? params[0] : '1',
      Email: dataForm.value.email ? dataForm.value.email : (params[0] !== '2') ? params[2] : '',
      IdentificationNumber: params[1] ? params[1] : '',
      TyCS: dataForm.value.termsAndConditions,
      PolPri: dataForm.value.ofers,
      Country: this.country,
      Language: this.language
    };

    if (params[2] && (params[0] === '2' || params[0] === '3' || params[0] === '4')) {
      body['CentroId'] = params[2];
    }

    if (params[0] === '3' || params[0] === '4') { // onBoarding
      body['Onboarding'] = params[1];
      body.IdentificationNumber = '';
      body.Email = '';
    }

    return this.http.post<Authentication>(environment.url + '/Account/TermsConditions',
      body, { headers: this.headers.set('recaptchaR', captcha) })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  /**
   * devuelde la key del captcha
   */
  getCaptchaKey(codePetition ?: string) {
    const code = codePetition ? '?codepetition=' + codePetition : '';
    return this.http.get(environment.url + '/OnInit' + code).pipe(retry(1), catchError(this.errorHandl));
  }

  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

  saveTyC(data) {
    return this.http.post(environment.url + '/login/TYC', data, { headers: this.headers.set('Authorization', sessionStorage.getItem('t')) }).pipe(retry(1), catchError(this.errorHandl));
  }
}
